import React from "react";
import { InputOnChangeData, SearchBoxChangeEvent } from "@fluentui/react-components";
import { PcpSearchBox } from "live-lesson/shared/feature-call-ui-react";
import { mergeStyles } from "@fluentui/react";

type CallParticipantListSearchBoxProps = {
    onValueChange: (event: SearchBoxChangeEvent, data: InputOnChangeData) => void;
    className?: string;
};


export const CallParticipantListSearchBox = (props: CallParticipantListSearchBoxProps): JSX.Element => (
    <div className={mergeStyles(props.className)}>
        <PcpSearchBox
            placeholder="Search participant"
            type={"text"}
            size="large"
            onChange={props.onValueChange}
            style={{ width: "100%" }}
        />
    </div>
);
